"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakTextEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/actions/core");
let SpeakTextEventHandlerScript = class SpeakTextEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__typeName !== "Killed" && container.isDeceased(event.subject)) {
            return;
        }
        const { percentChance = 100, text, color, size } = handler.args.scriptArgs;
        if ((0, Random_1.randomPercent)() <= percentChance) {
            container.dispatch(sequence, event.subject, new core_1.SpeakTextActionArgs(text, color, size));
        }
    }
};
SpeakTextEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("SpeakText")
], SpeakTextEventHandlerScript);
exports.SpeakTextEventHandlerScript = SpeakTextEventHandlerScript;
